'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.fetchEventsExecutor = fetchEventsExecutor;
exports.fetchAggregateEventsExecutor = fetchAggregateEventsExecutor;
exports.autofetchAggregateEventsExecutor = autofetchAggregateEventsExecutor;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _redux = require('@adparlor-devops/js-anvil/redux');

var _pick = require('lodash/object/pick');

var _pick2 = _interopRequireDefault(_pick);

var _identity = require('lodash/utility/identity');

var _identity2 = _interopRequireDefault(_identity);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _helpers = require('../../../helpers');

var _constants = require('../constants');

var _constants2 = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchEventsExecutor, fetchAggregateEventsExecutor, autofetchAggregateEventsExecutor].map(_regenerator2.default.mark);

function fetchEventsExecutor(_ref) {
  var payload = _ref.payload;
  var transactionId, searchTerm, ENDPOINTS, advertiserId, filter, params, request;
  return _regenerator2.default.wrap(function fetchEventsExecutor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          transactionId = payload.transactionId, searchTerm = payload.searchTerm;
          _context.next = 3;
          return (0, _effects.select)(function (state) {
            return state.session.ENDPOINTS;
          });

        case 3:
          ENDPOINTS = _context.sent;
          _context.next = 6;
          return (0, _effects.select)(function (state) {
            return state.session.currentAdvertiser;
          });

        case 6:
          advertiserId = _context.sent;
          _context.next = 9;
          return (0, _effects.select)(function (state) {
            return state.events.filter;
          });

        case 9:
          filter = _context.sent;
          params = (0, _pick2.default)((0, _extends3.default)({
            advertiserId: advertiserId,
            searchTerm: searchTerm
          }, (0, _helpers.getDateRange)(filter)), _identity2.default);
          _context.prev = 11;
          _context.next = 14;
          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/events/' + transactionId, { params: params });

        case 14:
          request = _context.sent;
          _context.next = 17;
          return (0, _effects.put)({ type: _constants.FETCH_EVENTS_SUCCESS, payload: { transactionId: transactionId, data: request.data } });

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context['catch'](11);
          _context.next = 23;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context.t0 });

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[11, 19]]);
}

function fetchAggregateEventsExecutor(_ref2) {
  var payload = _ref2.payload;
  var filterParams, advertiserId, ENDPOINTS, params, request;
  return _regenerator2.default.wrap(function fetchAggregateEventsExecutor$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          filterParams = payload.filterParams;
          _context2.next = 3;
          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: true });

        case 3:
          _context2.next = 5;
          return (0, _effects.select)(function (state) {
            return state.session.currentAdvertiser;
          });

        case 5:
          advertiserId = _context2.sent;
          _context2.next = 8;
          return (0, _effects.select)(function (state) {
            return state.session.ENDPOINTS;
          });

        case 8:
          ENDPOINTS = _context2.sent;
          params = (0, _pick2.default)((0, _extends3.default)({
            advertiserId: advertiserId,
            searchTerm: filterParams && filterParams.searchTerm,
            size: filterParams && filterParams.paginationSize || _constants2.AGGREGATE_EVENTS_PAGINATION_SIZE
          }, (0, _helpers.getDateRange)(filterParams)), _identity2.default);
          _context2.prev = 10;
          _context2.next = 13;
          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/aggregate-events', { params: params });

        case 13:
          request = _context2.sent;
          _context2.next = 16;
          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_SUCCESS, payload: request.data });

        case 16:
          _context2.next = 24;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2['catch'](10);
          _context2.next = 22;
          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: false });

        case 22:
          _context2.next = 24;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context2.t0 });

        case 24:
          _context2.next = 26;
          return (0, _effects.put)({ type: _constants.FETCH_AGGREGATE_EVENTS_LOADING, payload: false });

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[10, 18]]);
}

function autofetchAggregateEventsExecutor() {
  var dataRangePreventAutoRefreshList, advertiserId, locationPathname, filterParams, ENDPOINTS, currentAggregateEvent, params, request;
  return _regenerator2.default.wrap(function autofetchAggregateEventsExecutor$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          dataRangePreventAutoRefreshList = ['YESTERDAY', 'LAST_MONTH'];

        case 1:
          if (!true) {
            _context3.next = 35;
            break;
          }

          _context3.next = 4;
          return (0, _reduxSaga.delay)(_constants2.AUTO_FETCH_AGGREGATE_EVENTS_DELAY_TIME);

        case 4:
          _context3.next = 6;
          return (0, _effects.select)(function (state) {
            return state.session.currentAdvertiser;
          });

        case 6:
          advertiserId = _context3.sent;
          _context3.next = 9;
          return (0, _effects.select)(function (state) {
            return state.location.pathname;
          });

        case 9:
          locationPathname = _context3.sent;

          if (!(locationPathname !== '/advertisers/' + advertiserId + '/activity')) {
            _context3.next = 12;
            break;
          }

          return _context3.abrupt('break', 35);

        case 12:
          _context3.next = 14;
          return (0, _effects.select)(function (state) {
            return state.events.filter;
          });

        case 14:
          filterParams = _context3.sent;

          if (!(filterParams.filterRange && dataRangePreventAutoRefreshList.includes(filterParams.filterRange))) {
            _context3.next = 17;
            break;
          }

          return _context3.abrupt('break', 35);

        case 17:
          if (!(filterParams.filterRange === "DATE_RANGE" && filterParams.endTime && !(0, _moment2.default)(filterParams.endTime).isSame((0, _moment2.default)(), "day"))) {
            _context3.next = 19;
            break;
          }

          return _context3.abrupt('break', 35);

        case 19:
          _context3.next = 21;
          return (0, _effects.select)(function (state) {
            return state.session.ENDPOINTS;
          });

        case 21:
          ENDPOINTS = _context3.sent;
          _context3.next = 24;
          return (0, _effects.select)(function (state) {
            return state.events.aggregateEvents;
          });

        case 24:
          currentAggregateEvent = _context3.sent;
          params = (0, _pick2.default)((0, _extends3.default)({
            advertiserId: advertiserId,
            searchTerm: filterParams && filterParams.searchTerm,
            size: 1
          }, (0, _helpers.getDateRange)(filterParams)), _identity2.default);
          _context3.next = 28;
          return (0, _effects.call)(_axios2.default.get, ENDPOINTS.crossroads_api_url + '/aggregate-events', { params: params });

        case 28:
          request = _context3.sent;

          if (!(request.data.data[0] && request.data.data[0].transactionId !== currentAggregateEvent[0].transactionId)) {
            _context3.next = 33;
            break;
          }

          _context3.next = 32;
          return (0, _effects.put)({ type: _constants.AUTO_FETCH_AGGREGATE_EVENTS });

        case 32:
          return _context3.abrupt('break', 35);

        case 33:
          _context3.next = 1;
          break;

        case 35:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/events/sagas/executors.js
// module id = 3427
// module chunks = 2